var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.6667 5h-23.33337c-1.84166 0-3.33333 1.49167-3.33333 3.33333v23.33337c0 1.8416 1.49167 3.3333 3.33333 3.3333h23.33337c1.8416 0 3.3333-1.4917 3.3333-3.3333v-23.33337c0-1.84166-1.4917-3.33333-3.3333-3.33333zm-16.6667 23.3333h-4.205v-11.6666h4.205zm-2.1767-13.805c-1.285 0-2.1433-.8566-2.1433-2 0-1.1433.8567-2 2.285-2 1.285 0 2.1433.8567 2.1433 2 0 1.1434-.8566 2-2.285 2zm17.1767 13.805h-4.07v-6.3766c0-1.7634-1.085-2.17-1.4917-2.17-.4066 0-1.7633.2716-1.7633 2.17v6.3766h-4.205v-11.6666h4.205v1.6283c.5417-.95 1.6267-1.6283 3.6617-1.6283s3.6633 1.6283 3.6633 5.29z"
  })));
};
export default SvgLinkedin;